import React from "react";
import {
  ThinTextField,
  ThinTextAreaField,
} from "../../../common/GeneralComponent";
import { useSelector } from "react-redux";

const FeatureDetails = ({ data }) => {
  const authState = useSelector((state) => state.auth.user || {});
  const userPermissions = authState.user_permissions || [];

  const boq = data?.boqProposedDetails || {};
  const feature = boq?.Feature || {};
  const featureSubType = boq?.FeatureSubType || {};
  const featureCategory = boq?.FeaturesCategory || {};
  const implementation = data?.implementationDetails || {};

  const type = feature?.feature_name || "N/A";
  const subType = featureSubType?.feature_sub_type || "N/A";
  const category = featureCategory?.category_name || "N/A";
  // const code = featureCategory?.category_code || "N/A";
  const code = boq?.proposed_code || "N/A";
  const featureStatus =
    boq?.construction_type?.charAt(0).toUpperCase() +
      boq?.construction_type?.slice(1) || "N/A";

  const ownershipType = implementation?.feature_ownership || "N/A"; 
  const ownershipDetails = implementation?.details_of_feature || "N/A"; 

  const uploadedDocs = boq?.uploadedDocs || [];
  const upgradationStages = boq?.upgradationStages || [];

  return (
    <>
      {data ? (
        <div className="bg-white rounded p-4">
          <div className="mb-4">
            <h2 className="text-lg font-semibold text-gray-800">
              Feature / Infrastructure Details
            </h2>
          </div>

          <div className="border rounded-md p-4 mb-4 shadow-sm">
            {/* Header */}
            <div className="flex items-start justify-between mb-3">
              <div>
                <h3 className="text-md font-semibold">
                  {type}{" "}
                  <span className="text-sm font-normal text-gray-600">
                    {subType}
                  </span>
                </h3>
                <div className="text-xs text-gray-500 mt-1">
                  {category || "N/A"} {code ? `• ${code}` : ""}
                </div>
              </div>
            </div>

            {/* Feature details */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-3">
              <ThinTextField
                label="Feature Type"
                value={type}
                disabled
                isRequired={false}
              />
              <ThinTextField
                label="Sub-Type"
                value={subType}
                disabled
                isRequired={false}
              />
              <ThinTextField
                label="Category"
                value={category}
                disabled
                isRequired={false}
              />
              <ThinTextField
                label="Feature Code"
                value={code}
                disabled
                isRequired={false}
              />
              <ThinTextField
                label="Feature Information Status"
                value={featureStatus}
                disabled
                isRequired={false}
              />
              {/* Construction field removed as requested */}
            </div>

            {/* Ownership Section */}
            <div className="mb-3">
              <div className="text-sm font-semibold text-gray-700 mb-1">
                Feature Ownership
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <ThinTextField
                  label="Owner Type"
                  value={ownershipType}
                  disabled
                  isRequired={false}
                />
                <ThinTextAreaField
                  label="Owner Details"
                  value={ownershipDetails}
                  disabled
                  isRequired={false}
                />
              </div>
            </div>

            {/* Uploaded documents */}
            {uploadedDocs?.length > 0 && (
              <div className="mb-3">
                <div className="text-sm font-semibold text-gray-700 mb-1">
                  Uploaded Documents
                </div>
                <ul className="text-sm text-gray-700">
                  {uploadedDocs.map((doc, index) => (
                    <li key={index}>
                      <a
                        className="text-blue-700 hover:underline"
                        href={doc?.url || "#"}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {doc?.name || `Document ${index + 1}`}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {/* Upgradation stages */}
            {featureStatus === "Upgradation" &&
              upgradationStages?.length > 0 && (
                <div className="mb-3">
                  <div className="text-sm font-semibold text-gray-700 mb-1">
                    Upgradation Stages
                  </div>
                  <ul className="pl-4 space-y-1 text-sm">
                    {upgradationStages.map((stage, i) => (
                      <li key={i} className="flex items-center gap-3">
                        <span
                          className={`w-3 h-3 rounded-full ${
                            stage?.completed ? "bg-green-500" : "bg-gray-300"
                          }`}
                        />
                        <span>{stage?.name}</span>
                        <span className="ml-auto text-xs text-gray-500">
                          {stage?.completed ? "Completed" : "Pending"}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
          </div>
        </div>
      ) : (
        <h2 className="text-center my-6 text-md text-gray-600">
          Data not found
        </h2>
      )}
    </>
  );
};

export default FeatureDetails;